<template>
  <v-app-bar :color="returnColor()" fixed dense app>
    <loading
      :active="isload"
      :is-full-page="false"
      :opacity="0.7"
      color="#ff6b00"
    />
    <img
      src="../../assets/master_logo.png"
      alt="QQPay"
      style="max-height: 60px; max-width: 110px"
    />
    <v-spacer></v-spacer>
    <span class="white--text font-weight-bold"
      ><v-icon class="me-1" dark>mdi-account-circle</v-icon
      >{{ user_email }}</span
    >
    <v-btn
      depressed
      color="white"
      icon
      active-class="primary"
      @click="logoutDialog = true"
      title="Logout"
    >
      <v-icon>mdi-power</v-icon>
    </v-btn>
    <v-menu left bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          depressed
          icon
          v-bind="attrs"
          v-on="on"
          title="Menu"
          color="white"
        >
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item-group
          color="primary"
          active-class="orange--text text--accent-4"
        >
          <v-list-item
            v-for="(menuItem, idx) in menuList"
            :key="idx"
            link
            :to="menuItem.path"
            class="text-decoration-none"
            :disabled="!menuItem.isActive"
          >
            <v-list-item-title
              ><v-icon>{{ menuItem.icon }}</v-icon>
              {{ menuItem.title }}</v-list-item-title
            >
          </v-list-item>
        </v-list-item-group>
        <v-list-item class="border-bottom">
          <v-list-item-content>
            <v-list-item-subtitle class="text-overline"
              >{{ $t("app_version") }}
              <strong>v{{ appVersion }}</strong></v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- Logout confirmation popup dialog -->
    <v-dialog persistent v-model="logoutDialog" width="500">
      <v-card>
        <v-system-bar color="secondary" dark>
          <span>Logout</span>
          <v-spacer></v-spacer>
          <v-icon @click="logoutDialog = false">mdi-close</v-icon>
        </v-system-bar>
        <!-- <v-card-title class="border border-bottom">Logout</v-card-title> -->
        <v-card-text class="h5 py-3"
          >Are you sure you want to logout?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" @click="logout">
            <v-icon>mdi-check</v-icon>Yes
          </v-btn>
          <v-btn
            depressed
            color="primary"
            outlined
            @click="logoutDialog = false"
            ><v-icon>mdi-close</v-icon>No</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
const pjson = require("../../../package.json");
import Loading from "vue-loading-overlay";
import alerts from "@/mixins/alerts";
import agentService from "@/services/agentService/AgentService.js";
export default {
  mixins: [alerts],
  name: "NavBar",
  data() {
    return {
      appVersion: pjson.version,
      logoutDialog: false,
      user_email: "",
      isload: false,
      isMenuClosed: true,
      items: [],
      menuList: [
        {
          icon: "mdi-home-outline",
          title: "Home",
          path: "/home",
          isActive: true,
        },
        {
          icon: "mdi-cog-outline",
          title: "Settings",
          path: "/",
          isActive: true,
        },
        {
          icon: "mdi-help-circle-outline",
          title: "Help",
          path: "/",
          isActive: true,
        },
      ],
    };
  },
  components: {
    Loading,
  },
  mounted() {
    console.log("appVersion", this.appVersion);
    this.user_email = sessionStorage.getItem("username");
  },

  methods: {
    reloadComponent() {
      this.$emit("reload");
    },
    returnColor() {
      return `#${process.env.VUE_APP_COLOR}`;
    },
    async logout() {
      this.isload = true;
      try {
        const responseData = await agentService.Logout();
        this.isload = false;
        if (responseData && responseData.data.status_code === 200) {
          this.showAlertSuccess(responseData.data.message);
          sessionStorage.clear();
          this.isload = false;
          this.$router.push({ name: "Login" });
        } else {
          this.showAlertError(responseData.data.message);
        }
      } catch (e) {
        this.isload = false;
        this.showAlertError("Something went wrong please try again later.");
        console.error(e);
      }
    },
    toggleMenu() {
      this.isMenuClosed = !this.isMenuClosed;
      this.$emit("toggleMenu", this.isMenuClosed);
    },
  },
};
</script>
